<template>
  <div class="uploadUser">
    <div class="head">修改发布者信息</div>
    <el-form label-position="right" label-width="120px" :model="contentObj">
      <el-form-item label="发布者名称">
        <el-input
          type="text"
          placeholder="请输入发布者名称"
          v-model="contentObj.name"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="官网"
        ><el-input
          type="text"
          placeholder="请输入官网地址"
          v-model="contentObj.net"
        ></el-input
      ></el-form-item>
      <el-form-item label="邮箱"
        ><el-input
          type="text"
          placeholder="请输入邮箱地址"
          v-model="contentObj.email"
        ></el-input
      ></el-form-item>
      <el-form-item label="电话号码"
        ><el-input
          type="text"
          placeholder="请输入电话号码"
          v-model="contentObj.phone"
        ></el-input
      ></el-form-item>
      <el-form-item label="简介"
        ><el-input
          type="textarea"
          placeholder="请输入简介"
          v-model="contentObj.introduction"
          maxlength="100"
          show-word-limit
        ></el-input
      ></el-form-item>
        <el-form-item>
        <div class="btnList">
            <button class="sucess">确认</button>
            <button class="del">取消</button>
        </div>
    </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
    data(){
        return{
            contentObj:{
                name:'',
                net:'',
                email:'',
                phone:'',
                introduction:''
            }
        }
    }
};
</script>

<style scoped>
.sucess{
    background-color: #0D53FF;
    color: white;
  
}
.del{
    background-color: #fff;
    color: #666666;
    
}
.btnList button{
    width: 80px;
    height: 32px;
       border: 1px solid #E9E9E9;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}::v-deep .el-textarea textarea {
  width: 570px;
  height: 100px;
}
::v-deep .el-textarea  {
  width: 570px;
  height: 100px;
}
.head {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 27px;
}
.uploadUser {
  margin-top: 24px;
  margin-left: 24px;
  font-family: Regular;
}
</style>